
import { fetchWrapper, objectToQueryParams } from '../utils';

export class payment {
  static baseUrl = process.env.REACT_APP_BASE_API + 'app/plans';

  static async checkPayment(data) {
    const url = `${process.env.REACT_APP_BASE_API}app/home/check-payment`;
    return await fetchWrapper.post(url, data);
  }

  static async createOrder(data) {
    const url = `${this.baseUrl}/create-order`;
    return await fetchWrapper.post(url, data);
  }

  static async savePaypal(data) {
    const url = `${this.baseUrl}/save-paypal`;
    return await fetchWrapper.post(url, data);
  }

  static async getPayments(data) {
    const url = `${this.baseUrl}/get-payments`;
    return await fetchWrapper.post(url, data);
  }

  static async getPlanUser(data) {
    const url = `${this.baseUrl}/get-plan-user`;
    return await fetchWrapper.post(url, data);
  }


  static async validateMonths(data) {
    const url = `${this.baseUrl}/validate-months`;
    return await fetchWrapper.post(url, data);
  }
}

export class payer {
  static baseUrl = process.env.REACT_APP_BASE_API + 'common/payments';

  static async getConversion(data) {
    const url = `${this.baseUrl}/conversion?${objectToQueryParams(data)}`;
    return await fetchWrapper.get(url);
  }

  static async getMethods(data) {
    const url = `${this.baseUrl}/methods?${objectToQueryParams(data)}`;
    return await fetchWrapper.get(url);
  }

  static async getBanks(data) {
    const url = `${this.baseUrl}/banks?${objectToQueryParams(data)}`;
    return await fetchWrapper.get(url);
  }

  static async acquirePlan(data) {
    const url = `${this.baseUrl}/adquire`;
    return await fetchWrapper.post(url, data);
  }

  static async renewPlan(data) {
    const url = `${this.baseUrl}/renew`;
    return await fetchWrapper.post(url, data);
  }
}
